import { render, staticRenderFns } from "./versionData.vue?vue&type=template&id=346ff891&scoped=true"
import script from "./versionData.vue?vue&type=script&lang=js"
export * from "./versionData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346ff891",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('346ff891')) {
      api.createRecord('346ff891', component.options)
    } else {
      api.reload('346ff891', component.options)
    }
    module.hot.accept("./versionData.vue?vue&type=template&id=346ff891&scoped=true", function () {
      api.rerender('346ff891', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/basicData/channelVolume/cmp/versionData.vue"
export default component.exports